const routes = {
  loginPage: '/',
  register: '/register',
  interview: '/app/interview',
  scoresheet: '/app/interview/scoresheet', // ✅ new route
  confirmEmail: '/confirm-email',
  studentInterviewTab: '/app/student/interview',
  interviewBookslotTab:'/app/student/slot-booking'
};

export default routes;
